export default "__VITE_ASSET__DvETL48L__"